import React, { useState } from "react";
import * as Mui from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import pumpIconGreen from "../../images/pump-green.png";
import pumpIconYellow from "../../images/pump-yellow.png";
import pumpIconRed from "../../images/pump-red.png";
import pumpIconBlue from "../../images/pump-blue.png";
import pumpIconGray from "../../images/pump-gray.png";
import radioIconBlue from "../../images/radio-blue.png";
import radioIconRed from "../../images/radio-red.png";
import radioIconGreen from "../../images/radio-green.png";
import radioIconGray from "../../images/radio-gray.png";
import valveIconBlue from "../../images/valve-blue.png";
import valveIconGreen from "../../images/valve-green.png";
import valveIconGray from "../../images/valve-gray.png";
import valveIconRed from "../../images/valve-red.png";
import pivotIconGreen from "../../images/pivot-green.png";
import pivotIconBlue from "../../images/pivot-blue.png";
import {
  unitStateDisplay,
  unitStateDisplayColor,
  UnitState
} from "../../enums/unitState";
import { Redirect } from "react-router";
import { ThemeOptions } from "@material-ui/core";
import { MarkerCategory } from "../../enums/markerCategory";
import { sensorStateDisplay, sensorStateDisplayColor } from "../../enums/sensorAlarmStatus";
import { THEME_VARIABLES } from "../../themeColors";
import { fieldStateDisplay, fieldStateDisplayColor } from "../../enums/fieldStatus";

export const MapMarker = ({
  lat,
  lng,
  id,
  name,
  serialNumber,
  markerImageType,
  category,
  status,
  unitState,
  online,
  currentEngData,
  associatedValves,
  associatedPumps,
  isTooltipOpen,
  onMarkerClick,
  onTooltipOpen,
  onTooltipClose
}: {
  lat: number;
  lng: number;
  id: number;
  name: string;
  serialNumber: number;
  markerImageType: number;
  category: MarkerCategory;
  status: number | null;
  unitState: UnitState | undefined;
  online: boolean | null;
  currentEngData: number | null;
  associatedValves?: Array<{ id: number; name: string; state: string }>;
  associatedPumps?: Array<{ id: number; name: string; state: string }>;
  isTooltipOpen?: boolean;
  onMarkerClick?: () => void;
  onTooltipOpen?: () => void;
  onTooltipClose?: () => void;
}) => {
  const [redirectActive, setRedirectActive] = useState(false);

  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const resolvedTooltipOpen = category === MarkerCategory.Pivot
    ? !!isTooltipOpen
    : tooltipIsOpen;

  const openHandler = () => {
    onMarkerClick?.();
    if (category !== MarkerCategory.Pivot) {
      setTooltipIsOpen(true);
    }
    onTooltipOpen?.();
  };
  const closeHandler = () => {
    if (category !== MarkerCategory.Pivot) {
      setTooltipIsOpen(false);
    }
    onTooltipClose?.();
  };
  const statusColor = unitStateDisplayColor(unitState);
  const sensorColor = sensorStateDisplayColor(status !== null ? status : 0);
  const fieldColor = fieldStateDisplayColor(currentEngData !== null
    ? currentEngData : undefined,
    online !== null ? online : false);

  const classes = useStyles();

  var mapMarkerSource =
    markerImageType === 97 && online // pivot: green when online, blue otherwise
      ? pivotIconGreen
      : markerImageType === 97
        ? pivotIconBlue
        : markerImageType !== 99 && markerImageType !== 98 && statusColor === THEME_VARIABLES.COLOR_BLUE_1 // change Icon based on status color
      ? pumpIconBlue
      : markerImageType !== 99 && markerImageType !== 98 && statusColor === THEME_VARIABLES.COLOR_GREEN
        ? pumpIconGreen
        : markerImageType !== 99 && markerImageType !== 98 && statusColor === THEME_VARIABLES.COLOR_YELLOW
          ? pumpIconYellow
          : markerImageType !== 99 && markerImageType !== 98 &&
            statusColor === THEME_VARIABLES.COLOR_DARK_GRAY
            ? pumpIconGray
            : markerImageType !== 99 && markerImageType !== 98 //Red and all other cases
              ? pumpIconRed
              : markerImageType === 98 && fieldColor === THEME_VARIABLES.COLOR_DARK_GRAY
                ? valveIconGray // valve comms lost disconnected or no position
                : markerImageType === 98 && fieldColor === THEME_VARIABLES.COLOR_RED
                  ? valveIconRed // position is less than 11 (closed)
                  : markerImageType === 98 && fieldColor === THEME_VARIABLES.COLOR_GREEN
                    ? valveIconGreen // valve is open
                    : markerImageType === 98 && fieldColor === THEME_VARIABLES.COLOR_BLUE_1
                      ? valveIconBlue // No valve position does not make sense 11 - 75
                      : markerImageType === 99 && sensorColor === THEME_VARIABLES.COLOR_DARK_GRAY
                        ? radioIconGray // Not online
                        : sensorColor === THEME_VARIABLES.COLOR_GREEN
                          ? radioIconGreen
                          : sensorColor === THEME_VARIABLES.COLOR_BLUE_1
                            ? radioIconBlue
                            : sensorColor === THEME_VARIABLES.COLOR_RED
                              ? radioIconRed
                              : radioIconGray; // No Data

  return (
    <>
      {redirectActive && <Redirect to={`/pumps/${id}`} />}
      <Mui.Tooltip
        interactive
        open={resolvedTooltipOpen}
        onClick={openHandler}
        onDoubleClick={() =>
          category === MarkerCategory.Pump && setRedirectActive(true)
        }
        title={
          <div>
            <div className={classes.toolTipHeader}>
              <Mui.IconButton
                className={classes.closeIcon}
                onClick={closeHandler}
              >
                <CloseIcon fontSize={"small"} />
              </Mui.IconButton>
            </div>
            <div className={classes.toolTipContent}>
              <p>Name: {name}</p>
              <p>SN#: {serialNumber}</p>
              <p>
                Status:{" "}
                {(category === MarkerCategory.Pump && (
                  <span>{unitStateDisplay(unitState)}</span>
                )) ||
                  (category === MarkerCategory.Pivot && (
                    <span>{online ? "Online" : "Offline"}</span>
                  )) ||
                  (category === MarkerCategory.Field && (
                    <span color={
                      fieldColor === THEME_VARIABLES.COLOR_DARK_GRAY ?
                        THEME_VARIABLES.COLOR_WHITE :
                        fieldColor
                    }
                    >{fieldStateDisplay(currentEngData !== null ? currentEngData : undefined, online !== null ? online : false)}
                    </span>
                  )) ||
                  (category === MarkerCategory.Sensor && (
                    <span color={
                      sensorColor === THEME_VARIABLES.COLOR_DARK_GRAY ?
                        THEME_VARIABLES.COLOR_WHITE :
                        sensorColor
                    }
                    >
                      {sensorStateDisplay}
                    </span>
                  ))}
              </p>
              {currentEngData !== null && <p> Current Data: {currentEngData}</p>}
              {category === MarkerCategory.Pivot && (
                <div className={classes.equipmentGrid}>
                  <div>
                    <div className={classes.equipmentTitle}>Pumps</div>
                    {associatedPumps?.length
                      ? associatedPumps.map(pump => (
                        <div key={pump.id} className={classes.equipmentRow}>
                          <span>{pump.name}</span>
                          <span>{pump.state}</span>
                        </div>
                      ))
                      : <div className={classes.emptyState}>None</div>}
                  </div>
                  <div>
                    <div className={classes.equipmentTitle}>Valves</div>
                    {associatedValves?.length
                      ? associatedValves.map(valve => (
                        <div key={valve.id} className={classes.equipmentRow}>
                          <span>{valve.name}</span>
                          <span>{valve.state}</span>
                        </div>
                      ))
                      : <div className={classes.emptyState}>None</div>}
                  </div>
                </div>
              )}
              {category === MarkerCategory.Pump && (
                <div className={classes.tooltipActions}>
                  <Mui.Button
                    size="small"
                    variant="outlined"
                    fullWidth
                    onClick={() => setRedirectActive(true)}
                  >
                    View
                  </Mui.Button>
                </div>
              )}
            </div>
          </div>
        }
      >
        <img
          onClick={openHandler}
          style={{
            position: "relative",
            right: "26px",
            bottom: "52px"
          }}
          src={mapMarkerSource}
          alt="map marker"
        />
      </Mui.Tooltip>
    </>
  );
};

const useStyles = Mui.makeStyles((theme: any) => ({
  closeIcon: {
    padding: 0,
    margin: 0,
    "& svg": {
      color: theme.whiteColor
    }
  },
  toolTipHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  },
  toolTipContent: {
    padding: "0em 1em"
  },
  equipmentGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "0.75rem",
    minWidth: 280
  },
  equipmentTitle: {
    fontWeight: 700,
    marginBottom: "0.5rem",
    paddingBottom: "0.35rem",
    borderBottom: `1px solid ${THEME_VARIABLES.COLOR_GRAY_1 || "rgba(255,255,255,0.25)"}`
  },
  equipmentRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "0.5rem",
    fontSize: "0.875rem",
    marginBottom: "0.25rem"
  },
  emptyState: {
    opacity: 0.75,
    fontSize: "0.875rem"
  },
  tooltipActions: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${THEME_VARIABLES.COLOR_GRAY_1 || "rgba(255,255,255,0.25)"}`,
    "& button": {
      color: theme.whiteColor,
      borderColor: "rgba(255,255,255,0.55)",
      textTransform: "none"
    }
  },
  redStatus: {
    color: THEME_VARIABLES.COLOR_RED
  },
  yellowStatus: {
    color: THEME_VARIABLES.COLOR_YELLOW
  },
  blueStatus: {
    color: THEME_VARIABLES.COLOR_BLUE_1
  },
  greenStatus: {
    color: THEME_VARIABLES.COLOR_GREEN
  },
  grayStatus: {
    color: THEME_VARIABLES.COLOR_WHITE
  },
  whiteStatus: {
    color: THEME_VARIABLES.COLOR_WHITE
  }
}));
